import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
// import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as moment from 'moment';
import { Radio, TextField } from '@mui/material';
import * as service from '../../services/service';

function CaseStatusDetails() {
    const [state, setState] = useState({
        remarks: '', filename: '', filepath: ''
    });
    // const [civilIDCData, setCivilIDCData] = useState([]);
    // const [civilCEOData, setCivilCEOData] = useState([]);
    // const [civilSEOData, setCivilSEOData] = useState([]);
    // const [civilDivisionData, setCivilDivisionData] = useState([]);
    // const [civilIDCId, setCivilIDCId] = useState('');
    // const [civilCEOId, setCivilCEOId] = useState('');
    // const [civilSEOId, setCivilSEOId] = useState('');
    // const [civilDivisionId, setCivilDivisionId] = useState('');
    const [courtData, setCourtData] = useState([]);
    const [courtId, setCourtId] = useState('');
    const [caseTypeData, setCaseTypeData] = useState([]);
    const [caseTypeId, setCaseTypeId] = useState('');
    const [caseData, setCaseData] = useState([]);
    const [caseDataForDropdown, setCaseDataForDropdown] = useState([]);
    const [caseId, setCaseId] = useState('');
    const [caseDetails, setCaseDetails] = useState([]);
    const [data, setData] = useState([]);
    const [statusDate, setStatusDate] = useState(new Date());
    const [caseStageData, setCaseStageData] = useState([]);
    const [caseStageId, setCaseStageId] = useState('');
    const [detailId, setDetailId] = useState('');
    const [caseStatusData, setCaseStatusData] = useState([]);
    const [caseStatusId, setCaseStatusId] = useState('');
    const [statusFile, setStatusFile] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [opinion, setOpinion] = useState('');
    const opinionData = [{ label: "File an appeal", value: "File an appeal" }, { label: "No Appeal", value: "No Appeal" }];
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    // const params = useParams();
    // const navigate = useNavigate();
    const userTyp = JSON.parse(sessionStorage.getItem('userData')).userType;

    // const getCivilIDCs = () => {
    //     fetch(
    //         service.CIVILIDC_URL,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json'
    //             },
    //         })
    //         .then(res => res.json())
    //         .then(result => {
    //             const data2 = result.map((item) => ({ value: item.civilIDCId, label: item.civilIDC }));
    //             setCivilIDCData(data2);
    //         });
    // };

    // const getCivilCEOs = (id) => {
    //     fetch(
    //         service.GET_CIVILCEO_BY_IDC_ID,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({
    //                 CivilIDCId: id,
    //             })
    //         })
    //         .then(res => res.json())
    //         .then(result => {
    //             const data2 = result.map((item) => ({ value: item.civilCEOId, label: item.civilCEO }));
    //             setCivilCEOData(data2);
    //         });
    // };

    // const getCivilSEOs = (id) => {
    //     fetch(
    //         service.GET_CIVILSEO_BY_CEO_ID,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({
    //                 CivilCEOId: id,
    //             })
    //         })
    //         .then(res => res.json())
    //         .then(result => {
    //             const data2 = result.map((item) => ({ value: item.civilSEOId, label: item.civilSEO }));
    //             setCivilSEOData(data2);
    //         });
    // };

    // const getCivilDivisions = (id) => {
    //     fetch(
    //         service.GET_CIVIL_DIVISION_BY_SEO_ID,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({
    //                 CivilSEOId: id,
    //             })
    //         })
    //         .then(res => res.json())
    //         .then(result => {
    //             const data2 = result.map((item) => ({ value: item.civilDivisionId, label: item.civilDivision }));
    //             setCivilDivisionData(data2);
    //         });
    // };
    const getCourts = () => {
        fetch(
            service.COURTS_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.courtId, label: item.court }));
                setCourtData(data2);
            });
    };

    const getCaseTypes = (id) => {
        fetch(
            service.GET_CASE_TYPE_BY_COURT_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CourtId: id
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.caseTypeId, label: item.caseType }));
                setCaseTypeData(data2);
            });
    };
    const getCaseDetails = (id) => {
        const errs = {};
        let url = service.GET_CASE_DETAILS_BY_CASE_TYPE_ID;
        if (userTyp === "Advocate") {
            url = service.GET_CASE_DETAILS_BY_ADVOCATE_ID
        }
        fetch(
            url,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CaseTypeId: id,
                    AddedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                })
            })
            .then(res => res.json())
            .then(result => {
                setCaseData(result);
                const data2 = result.map((item) => ({ value: item.caseId, label: item.caseNo }));
                setCaseDataForDropdown(data2);
            })
            .catch(err => {
                if (err) {
                    errs[".invalid"] = err;
                    setErrors(err);
                };
            });
    };
    const getCaseStages = (id) => {
        const errs = {};
        fetch(
            service.GET_CASE_STAGE_DETAILS_BY_CASE_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CaseId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                setCaseStageData(result);
            })
            .catch(err => {
                if (err) {
                    errs[".invalid"] = err;
                    setErrors(err);
                };
            });
    };

    const getCaseStatus = () => {
        const errs = {};
        fetch(
            service.CASE_STATUS_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.statusId, label: item.caseStatus }));
                setCaseStatusData(data2);
            })
            .catch(err => {
                if (err) {
                    errs[".invalid"] = err;
                    setErrors(err);
                };
            });
    };

    const getDetails = (id) => {
        const errs = {};
        fetch(
            service.GET_CASE_STATUS_DETAILS_BY_CASE_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CaseId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                setData(result);
            })
            .catch(err => {
                if (err) {
                    errs[".invalid"] = err;
                    setErrors(err);
                };
            });
    };

    const getDetailsById = (id) => {
        setLoading(true);
        const errs = {};
        fetch(
            service.GET_CASE_STATUS_DETAILS_BY_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    DetailId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.message.messageType === 'Success') {
                    setState({
                        ...state, remarks: result.remarks, filename: result.fileName, filepath: result.filePath
                    });

                    const stgData = ({ value: result.statusId, label: result.caseStatus });
                    setCaseStatusId(stgData);
                    setStatusDate(new Date(result.statusDate));
                    setCaseStageId(result.caseStageId);
                    setDetailId(result.caseStageDetailId);

                    const opi = ({ value: result.legalAdvisorOpinion, label: result.legalAdvisorOpinion });
                    setOpinion(opi);
                }
                else {
                    errs[".invalid"] = result.message.message;
                    setErrors(errs);
                }
            });
        setLoading(false);
    };

    const handleEdit = (id) => {
        getDetailsById(id);
        localStorage.setItem("ID", JSON.stringify(id));
    }

    useEffect(() => {
        setLoading(true);
        // getCivilIDCs();
        getCaseStatus();
        getCourts();
        setLoading(false);
    }, []);

    function getExtension(filename) {
        return filename.split('.').pop()
    }

    const validate = () => {
        let isValid = true;
        const maxSize = 5120; // in KB = 5MB
        const errs = {};
        if (!caseId) {
            isValid = false;
            errs[".caseId"] = "Please select Case";
        }
        if (!caseStageId && !detailId) {
            isValid = false;
            errs[".caseStageId"] = "Please select Case Stage";
        }
        if (!statusDate) {
            isValid = false;
            errs[".statusDate"] = "Please select Status Date";
        }
        if (!caseStatusId) {
            isValid = false;
            errs[".caseStatusId"] = "Please select Case Status";
        }
        if (statusFile && getExtension(statusFile.name).toLowerCase() !== 'pdf') {
            isValid = false;
            errs[".statusFile"] = "Please upload pdf file";
        }
        if (statusFile && statusFile.size / 1024 > maxSize) {
            isValid = false;
            errs[".statusFile"] = "File size limit 5 MB";
        }

        setErrors(errs);
        return isValid;
    }

    const changeHandler = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };
    // const CivilIDCChangeHandler = (ev) => {
    //     setCivilIDCId(ev);
    //     setCivilCEOId(null);
    //     getCivilCEOs(ev.value);
    // }
    // const CivilCEOChangeHandler = (ev) => {
    //     setCivilCEOId(ev);
    //     setCivilSEOId(null);
    //     getCivilSEOs(ev.value);
    // }
    // const CivilSEOChangeHandler = (ev) => {
    //     setCivilSEOId(ev);
    //     setCivilDivisionId(null);
    //     getCivilDivisions(ev.value);
    // }
    // const CivilDivisionChangeHandler = (ev) => {
    //     setCivilDivisionId(ev);
    //     setCaseId(null);
    //     setCaseDetails([]);
    // }
    const CourtChangeHandler = (ev) => {
        setCourtId(ev);
        setCaseTypeId(null);
        getCaseTypes(ev.value);
    }
    const CaseTypeChangeHandler = (ev) => {
        setCaseTypeId(ev);
        setCaseId(null);
        getCaseDetails(ev.value);
    }

    const CaseChangeHandler = (ev) => {
        setCaseId(ev);
        const details = caseData.find(x => x.caseId === ev.value);
        setCaseDetails(details);
        getCaseStages(ev.value);
        getDetails(ev.value);
    }

    const CaseStatusChangeHandler = (ev) => {
        setCaseStatusId(ev);
    }
    const OpinionChangeHandler = (ev) => {
        setOpinion(ev);
    }
    const handleRadioChange = (stgId, detId) => {
        setCaseStageId(stgId);
        setDetailId(detId);
    }

    const clearHandler = () => {
        localStorage.setItem('ID', null);
        setState({
            ...state, remarks: '', filename: '', filepath: ''
        });
        // const idc = ({ value: null, label: "Select Civil IDC" });
        // setCivilIDCId(idc);
        // const ceo = ({ value: null, label: "Select Civil CEO" });
        // setCivilCEOId(ceo);
        // const seo = ({ value: null, label: "Select Civil SEO" });
        // setCivilSEOId(seo);
        // const div = ({ value: null, label: "Select Civil Division" });
        // setCivilDivisionId(div);
        const ca = ({ value: null, label: "Select Case" });
        setCaseId(ca);
        const co = ({ value: null, label: "Select Court" });
        setCourtId(co);
        const ty = ({ value: null, label: "Select Case Type" });
        setCaseTypeId(ty);
        const st = ({ value: null, label: "Select Case Status" });
        setCaseStatusId(st);
        const op = ({ value: '', label: "Select Opinion" });
        setOpinion(op);
        setCaseStageData([]);
        setCaseDetails([]);
        setData([]);
    }

    const handleDownload = (fileName, filePath) => {
        setLoading(true);
        const formData = new FormData();
        formData.append("FileName", fileName);
        formData.append("FilePath", filePath);
        fetch(
            service.DOWNLOAD_FILE,
            {
                method: 'POST',
                body: formData,
                headers: {
                    'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                },
            })
            .then((response) => response.blob())
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    fileName,
                );
                // Append to html link element page
                document.body.appendChild(link);
                // Start download
                link.click();
                // Clean up and remove the link
                link.parentNode.removeChild(link);
            });

        setLoading(false);
    };

    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validate()) {
            const formData = new FormData();
            formData.append("DetailId", JSON.parse(localStorage.getItem('ID')) !== null ? JSON.parse(localStorage.getItem('ID')) : 0);
            formData.append("CaseId", caseId.value);
            formData.append("CaseStageId", caseStageId);
            formData.append("CaseStageDetailId", detailId);
            formData.append("StatusId", caseStatusId.value);
            formData.append("StatusDate", (new Date(statusDate)).toUTCString());
            formData.append("Remarks", state.remarks);
            formData.append("LegalAdvisorOpinion", opinion.value);
            formData.append("AddedBy", JSON.parse(sessionStorage.getItem('userData')).userId);
            formData.append("UpdatedBy", JSON.parse(sessionStorage.getItem('userData')).userId);
            formData.append("StatusFile", statusFile);
            fetch(
                service.ADD_UPDATE_CASE_STATUS_DETAILS,
                {
                    method: 'POST',
                    body: formData,
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        localStorage.setItem('ID', null);
                        // window.location.reload();
                        setState({ ...state, remarks: '', filename: '', filepath: '' });
                        const st = ({ value: null, label: "Select Case Status" });
                        setCaseStatusId(st);
                        setDetailId(null);
                        setCaseStageId(null);
                        getDetails(caseId.value);
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                    }
                    else {
                        errs[".invalid"] = result.message;
                        setErrors(errs);
                    }
                });
        }
        setLoading(false);
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Case Status Details
                                </MDTypography>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                <Table>
                                    <TableBody>
                                        {/* <TableRow>
                                            <TableCell width="45%">
                                                <Select
                                                    name="Civil IDC"
                                                    options={civilIDCData} placeholder="Select Civil IDC"
                                                    value={civilIDCId}
                                                    onChange={CivilIDCChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".civilIDCId"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <Select
                                                    name="Civil CEO"
                                                    options={civilCEOData} placeholder="Select Civil CEO"
                                                    value={civilCEOId}
                                                    onChange={CivilCEOChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".civilCEOId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <Select
                                                    name="Civil SEO"
                                                    options={civilSEOData} placeholder="Select Civil SEO"
                                                    value={civilSEOId}
                                                    onChange={CivilSEOChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".civilSEOId"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <Select
                                                    name="Civil Division"
                                                    options={civilDivisionData} placeholder="Select Civil Division"
                                                    value={civilDivisionId}
                                                    onChange={CivilDivisionChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".civilDivisionId"]}</div>
                                            </TableCell>
                                        </TableRow> */}
                                        <TableRow>
                                            <TableCell>
                                                <Select
                                                    name="Court"
                                                    options={courtData} placeholder="Select Court"
                                                    value={courtId}
                                                    onChange={CourtChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".courtId"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <Select
                                                    name="Case Type"
                                                    options={caseTypeData} placeholder="Select Case Type"
                                                    value={caseTypeId}
                                                    onChange={CaseTypeChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".caseTypeId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <Select
                                                    name="Case"
                                                    options={caseDataForDropdown} placeholder="Select Case"
                                                    value={caseId}
                                                    onChange={CaseChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".caseId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ fontSize: '14px' }}>
                                                Case No : {caseDetails ? caseDetails.caseNo : ''}
                                            </TableCell>
                                            <TableCell style={{ fontSize: '14px' }}>
                                                Notice No : {caseDetails ? caseDetails.noticeNo : ""}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ fontSize: '14px' }}>
                                                Notice Date : {caseDetails ? moment(caseDetails.noticeDate).format('DD/MM/YYYY') : ""}
                                            </TableCell>
                                            <TableCell style={{ fontSize: '14px' }}>
                                                Project : {caseDetails ? caseDetails.project : ""}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ fontSize: '14px' }}>
                                                Case Subject : {caseDetails ? caseDetails.caseSubject : ''}
                                            </TableCell>
                                            <TableCell style={{ fontSize: '14px' }}>
                                                Complainant : {caseDetails ? caseDetails.complainant : ""}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ fontSize: '14px' }}>
                                                Civil IDC : {caseDetails ? caseDetails.civilIDC : ''}
                                            </TableCell>
                                            <TableCell style={{ fontSize: '14px' }}>
                                                Civil CEO : {caseDetails ? caseDetails.civilCEO : ""}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ fontSize: '14px' }}>
                                                Civil SEO : {caseDetails ? caseDetails.civilSEO : ''}
                                            </TableCell>
                                            <TableCell style={{ fontSize: '14px' }}>
                                                Civil Division : {caseDetails ? caseDetails.civilDivision : ""}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="4">
                                                <Table aria-label="simple table" border>
                                                    <TableRow>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Select</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Case Stage</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Hearing Date</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Hearing Time</TableCell>
                                                        <TableCell style={{ fontWeight: 'bold' }}>Remarks</TableCell>
                                                    </TableRow>
                                                    <TableBody>
                                                        {caseStageData.map((row) => (
                                                            <TableRow
                                                                key={row.detailId}
                                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                            >
                                                                <TableCell><Radio onChange={() => handleRadioChange(row.caseStageId, row.detailId)}
                                                                    value={row.detailId} name="radio-buttons"
                                                                    checked={detailId === row.detailId} />
                                                                </TableCell>
                                                                <TableCell>{row.caseStage}</TableCell>
                                                                <TableCell>{moment(row.hearingDate).format('DD/MM/YYYY')}</TableCell>
                                                                <TableCell>{row.hearingTime}</TableCell>
                                                                <TableCell>{row.remarks}</TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".caseStageId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        {/* <TableRow>
                                            <TableCell style={{ fontSize: '14px' }}>
                                                Hearing Date : {caseStageDetails ? moment(caseStageDetails.hearingDate).format('DD/MM/YYYY') : ""}
                                            </TableCell>
                                            <TableCell style={{ fontSize: '14px' }}>
                                                Hearing Time : {caseStageDetails ? caseStageDetails.hearingTime : ""}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ fontSize: '14px' }}>
                                                Remarks : {caseStageDetails ? caseStageDetails.remarks : ""}
                                            </TableCell>
                                        </TableRow> */}
                                        <TableRow>
                                            <TableCell width="50%">
                                                Status Date
                                                <DatePicker
                                                    id="statusDate"
                                                    selected={statusDate}
                                                    onChange={date => setStatusDate(date)}
                                                    dateFormat="MM/dd/yyyy"
                                                    tabIndex={0}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".statusDate"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <Select
                                                    name="Case Status"
                                                    options={caseStatusData} placeholder="Select Case Status"
                                                    value={caseStatusId}
                                                    onChange={CaseStatusChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".caseStatusId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                Status File (File Size 5 MB)
                                                <br />
                                                <TextField
                                                    id="statusFile"
                                                    type="file"
                                                    onChange={ev => setStatusFile(ev.target.files[0])}
                                                    style={{ width: 200 }}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".statusFile"]}</div>
                                                {state.filename ?
                                                    <MDButton onClick={() => handleDownload(state.filename, state.filepath)}>{state.filename}</MDButton>
                                                    : null}
                                            </TableCell>
                                            <TableCell>
                                                <MDInput label="Remarks" fullWidth value={state.remarks || ''}
                                                    name="remarks"
                                                    onChange={changeHandler}
                                                    id="remarks"
                                                    required
                                                    multiline
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".remarks"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                Legal Advisor Opinion
                                                <Select
                                                    name="opinion"
                                                    options={opinionData}
                                                    value={opinion}
                                                    onChange={OpinionChangeHandler}
                                                    placeholder="Select Opinion"
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".opinion"]}</div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                                <MDBox mt={4} mb={1} textAlign="center">
                                    {loading ? <Oval
                                        heigth="20"
                                        width="20"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                        <div>
                                            <MDButton color="info" onClick={submitHandler}>
                                                SAVE
                                            </MDButton>&nbsp;&nbsp;&nbsp;&nbsp;
                                            <MDButton color="info" onClick={clearHandler}>
                                                Clear
                                            </MDButton>
                                        </div>
                                    }
                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                </MDBox>

                            </Card>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">
                                            <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                <TableCell style={{ fontWeight: 'bold' }}>Case Stage</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Status Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Case Status</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Remarks</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                                            </TableRow>
                                            <TableBody>
                                                {data.map((row) => (
                                                    <TableRow
                                                        key={row.detailId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell>{row.caseStage}</TableCell>
                                                        <TableCell>{moment(row.statusDate).format('DD/MM/YYYY')}</TableCell>
                                                        <TableCell>{row.caseStatus}</TableCell>
                                                        <TableCell>{row.remarks}</TableCell>
                                                        <TableCell><MDButton onClick={() => handleEdit(row.detailId)}>Edit</MDButton></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                }
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default CaseStatusDetails;